PegasusTemplate.HideableMixin = Em.Mixin.create({
  didInsertElement: function(){
    this._super();
    this.bindVisibilityToggle();
  },

  willDestroyElement: function(){
    this.unbindVisibilityToggle();
    this._super();
  },
  bindVisibilityToggle: function(){
    $(window).on('didToggleImageDisplayMode.' + this.get('elementId'), this.didToggleImageDisplayMode.bind(this));
  },

  unbindVisibilityToggle: function(){
    $(window).off('didToggleImageDisplayMode.' + this.get('elementId'));
  },

  didToggleImageDisplayMode: function(){
    Em.run(this, function(){
      this.set('controller.dataIsDisplayed',
        this.get('controller.dataIsDisplayed') === '' ?
          'true' : '' );
    });
  }
});

PegasusTemplate.EmailPreferencesHideableMixin = Em.Mixin.create({
  didInsertElement: function(){
    this._super();
    this.bindEmailPreferencesVisibilityToggle();
  },

  willDestroyElement: function(){
    this.unbindEmailPreferencesVisibilityToggle();
    this._super();
  },
  bindEmailPreferencesVisibilityToggle: function(){
    $(window).on('didToggleEmailPreferencesDisplayMode.' + this.get('elementId'), this.didToggleEmailPreferencesDisplayMode.bind(this));
  },

  unbindEmailPreferencesVisibilityToggle: function(){
    $(window).off('didToggleEmailPreferencesDisplayMode.' + this.get('elementId'));
  },

  didToggleEmailPreferencesDisplayMode: function(){
    Em.run(this, function(){
      this.set('controller.isFooterEmailPreferencesEnabled',
        this.get('controller.isFooterEmailPreferencesEnabled') === '' ?
          'true' : '' );
    });
  }
});
